
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-hub",
      function () {
        return require("private-next-pages/data-hub.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-hub"])
      });
    }
  